import {
  VALUATION_INITIALIZE_STATE,
  ADD_TYV_VALUATION_REQUEST,
  ADD_TYV_VALUATION_SUCCESS,
  ADD_TYV_VALUATION_FAILURE,
  VALUATION_REFRESH_HOME_DATA_SUCCESS,
  VALUATION_REFRESH_HOME_DATA_FAILURE,
  FETCH_HOME_SUCCESS,
  SET_VALUATION_HOME_FACTS_PROGRESS,
  FETCH_VALUATION_HISTORY_SUCCESS,
  SET_VALUATION_NEEDS_REFRESH
} from './actionTypes'
import { getHomeDetail } from 'src/api/node/requests'
import {
  postValuationAmountForHomeUuid,
  getValuationHistory
} from 'src/api/mikasa/requests'
import { flashNotification } from 'src/actions/notification'
import { HOME_DETAIL_UPDATE_ERROR } from 'src/constants/messages'
import { AVM_TUNE_TYPES } from 'src/constants/valuation'
import { selectClientId } from 'src/store/selectors/client'
import { selectHomeId } from 'src/store/selectors/home'
import { selectHomeRefreshRequired } from 'src/store/selectors/valuation'

export const refreshHomeDetailFromValuation = (
  clientId,
  homeId
) => async dispatch => {
  try {
    const [detailResponse, valuesResponse] = await Promise.all([
      getHomeDetail(homeId),
      getValuationHistory(clientId, homeId)
    ])

    dispatch({
      type: FETCH_HOME_SUCCESS,
      data: detailResponse.data
    })
    dispatch({
      type: FETCH_VALUATION_HISTORY_SUCCESS,
      data: valuesResponse.data,
      homeId
    })

    dispatch({
      type: VALUATION_REFRESH_HOME_DATA_SUCCESS
    })
  } catch (error) {
    dispatch(
      flashNotification({
        message: HOME_DETAIL_UPDATE_ERROR.defaultMessage,
        messageType: 'error'
      })
    )
    dispatch({
      type: VALUATION_REFRESH_HOME_DATA_FAILURE,
      error
    })
  }
}

export const addHomeValuation = (
  homeId,
  homeUuid,
  amount,
  updated = true
) => async (dispatch, getState) => {
  const clientId = selectClientId(getState())
  const tuneType = AVM_TUNE_TYPES.TYV

  dispatch({
    type: ADD_TYV_VALUATION_REQUEST,
    amount,
    updated
  })

  try {
    await postValuationAmountForHomeUuid(homeUuid, amount, tuneType)
    dispatch({
      type: ADD_TYV_VALUATION_SUCCESS,
      updated
    })
    if (updated) {
      dispatch(refreshHomeDetailFromValuation(clientId, homeId))
    }
  } catch (error) {
    dispatch({
      type: ADD_TYV_VALUATION_FAILURE,
      error
    })
  }
}

export const runValuationComplete = () => async (dispatch, getState) => {
  const state = getState()
  const homeId = selectHomeId(state)
  const clientId = selectClientId(state)
  const refresh = selectHomeRefreshRequired(state)

  if (refresh) {
    dispatch(refreshHomeDetailFromValuation(clientId, homeId))
  } else {
    dispatch({
      type: VALUATION_REFRESH_HOME_DATA_SUCCESS
    })
  }
}

export const flagValuationForUpdate = () => async dispatch =>
  dispatch({ type: SET_VALUATION_NEEDS_REFRESH })

export const setValuationHomeFactsProgress = p => async dispatch =>
  dispatch({ type: SET_VALUATION_HOME_FACTS_PROGRESS, progress: p })

export const intializeState = () => async dispatch =>
  dispatch({ type: VALUATION_INITIALIZE_STATE })
